import { cn } from "@/lib/utils";
import { getScoreTier } from "@/lib/theme";

interface TierBadgeProps {
  score: number;
  className?: string;
}

export function TierBadge({ score, className }: TierBadgeProps) {
  const tier = getScoreTier(score);
  if (!tier) return null;

  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded font-brand text-[11px] tracking-wider uppercase",
        tier.pulse && "animate-pulse-glow",
        className
      )}
      style={{
        color: tier.color,
        backgroundColor: `${tier.color}15`,
        border: `1px solid ${tier.color}40`,
      }}
    >
      {tier.name}
    </span>
  );
}
